import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Profile from "./components/profile";
import NotFound from "./components/notFound";
import NavBar from "./components/navBar";
import LoginForm from "./components/loginForm";
import RegisterForm from "./components/registerForm";
import ForgotPasswordForm from "./components/forgotPasswordForm";
import forgotPasswordUpdateForm from "./components/forgotPasswordUpdateForm";
import Logout from "./components/logout";
import ProtectedRoute from "./components/common/protectedRoute";
import Home from "./components/home";
import Subscriptions from "./components/subscriptions";
import auth from "./services/authService";
import "react-toastify/dist/ReactToastify.css";
import { withStyles } from "@material-ui/core/styles";
import "./App.css";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { apiUrl } from "./config";

const styles = (theme) => ({
  container: {
    paddingRight: 15,
    paddingLeft: 15,
    marginRight: "auto",
    marginLeft: "auto",

    [theme.breakpoints.up("md")]: {
      // medium: 960px or larger
      width: 920,
    },
    [theme.breakpoints.up("lg")]: {
      // large: 1280px or larger
      width: 1170,
    },
    [theme.breakpoints.up("xl")]: {
      // extra-large: 1920px or larger
      width: 1366,
    },
  },
});

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#00BCD4",
    },
  },
});

export class App extends Component {
  state = {};

  componentDidMount() {
    const user = auth.getCurrentUser();
    this.setState({ user });
  }

  render() {
    const { user } = this.state;

    return (
      <MuiThemeProvider theme={theme}>
        <React.Fragment>
          <ToastContainer />
          <NavBar user={user} />

          <main
            className={this.props.classes.container}
            style={{ maxWidth: "800px" }}
          >
            <Switch>
              <Route path="/w/register" component={RegisterForm} />
              <Route path="/w/login" component={LoginForm} />
              <Route path="/w/logout" component={Logout} />
              <Route path="/w/forgot-password" component={ForgotPasswordForm} />
              <Route
                path="/w/forgot-password-update/:id/:code"
                component={forgotPasswordUpdateForm}
              />
              <ProtectedRoute path="/w/profile" component={Profile} />
              <ProtectedRoute
                path="/w/subscriptions"
                component={Subscriptions}
              />
              <Route path="/w/not-found" component={NotFound} />
              <Route path="/w/" component={Home} />
            </Switch>
            <br />
            <br />
            <br />
            <hr />
            <div>
              <a
                href="http://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf"
                target="_blank"
              >
                <img
                  style={{ height: "50px" }}
                  src={
                    apiUrl +
                    "/assets/images/simplepay_bankcard_logos_top_01.jpg"
                  }
                  title="SimplePay - Online bankkártyás fizetés"
                  alt="SimplePay vásárlói tájékoztató"
                />
              </a>
              &nbsp;|&nbsp;
              <a
                target="_blank"
                href="https://legter.hu/altalanos-szerzodesi-feltetelek/"
              >
                ÁSZF
              </a>
              &nbsp;|&nbsp;
              <a target="_blank" href="https://legter.hu/suti-szabalyzat/">
                Süti szabályzat
              </a>
              &nbsp;|&nbsp;
              <a
                target="_blank"
                href="https://legter.hu/adatkezelesi-tajekoztato/"
              >
                Adatvédelmi tájékoztató
              </a>
            </div>
            <br />
            <br />
          </main>
        </React.Fragment>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(App);
